import type { RecentFile } from '@/types';
import { downloadFile } from '../api/templates/crud';

const toUtf8Bytes = (content: string): ArrayBuffer =>
  new TextEncoder().encode(content).buffer;

export const decodeRecentFilePayload = (payload: string): ArrayBuffer => {
  let encodedData = payload;

  try {
    const parsedPayload = JSON.parse(payload);

    if (typeof parsedPayload === 'string') {
      encodedData = parsedPayload;
    } else {
      return toUtf8Bytes(JSON.stringify(parsedPayload));
    }
  } catch {
    // Some backends return raw base64/text payload without JSON string wrapping.
  }

  let binaryString = '';

  try {
    binaryString = atob(encodedData);
  } catch {
    return toUtf8Bytes(encodedData);
  }

  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer;
};

export const fetchRecentFile = async (
  recentFiles: RecentFile[] | undefined,
  fileId: string,
): Promise<File> => {
  const recentFile = recentFiles?.find((file) => file.fileId === fileId);
  if (!recentFile) {
    throw new Error('Recent file not found');
  }

  const bytes = decodeRecentFilePayload(await downloadFile(fileId));

  // copied from use-recent-files
  return new File([bytes], recentFile.fileName, {
    type: recentFile.mimeType || 'application/octet-stream',
    lastModified: new Date(recentFile.usedAt).getTime(),
  });
};
